import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { BottomSheet, Picker } from '@adc/parallax-component-library';
import i18n from 'Utilities/i18n';
const mapStateToProps = ({ config, scrollPage: { mainSize } }) => {
    return {
        supportedCountries: config.supportedCountries,
        mainSize,
    };
};
const PICKER_WHEEL_WIDTH = 80;
const connector = connect(mapStateToProps);
const GenderPicker = ({ onDone, mainSize, selectedGender, isOpen }) => {
    const [selectedItemIndex, setSelectedItemIndex] = useState(0);
    const ref = useRef(null);
    const pickerRef = useRef(null);
    const genders = useMemo(() => [
        { key: 'female', label: i18n.t('Global.microcopy.genderOptions.female') },
        { key: 'male', label: i18n.t('Global.microcopy.genderOptions.male') },
        { key: 'undetermined', label: i18n.t('Global.microcopy.genderOptions.other') },
    ], []);
    const gendersLabel = useMemo(() => genders.map((gender) => gender.label), [genders]);
    useEffect(() => {
        if (isOpen) {
            ref.current?.present();
        }
        else {
            ref.current?.close();
        }
    }, [isOpen]);
    useEffect(() => {
        if (selectedGender) {
            const index = genders.findIndex((gender) => gender.key === selectedGender);
            setSelectedItemIndex(index);
        }
    }, [selectedGender, genders]);
    return (React.createElement(BottomSheet, { ref: ref, enableDynamicSizing: true, testID: "GenderPicker", topNavigationProps: {
            lightTitle: true,
            title: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.gender.label'),
            buttonEnd: {
                element: i18n.t('Global.microcopy.common.done'),
                onPress: () => {
                    onDone(genders[selectedItemIndex].key);
                },
            },
        } },
        React.createElement("div", { style: {
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column',
                maxHeight: mainSize / 2,
            } },
            React.createElement(Picker, null,
                React.createElement(Picker.Wheel, { width: PICKER_WHEEL_WIDTH, ref: pickerRef, items: gendersLabel, ariaLabel: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.gender.placeholder'), onSelect: setSelectedItemIndex, initialSelectedIndex: selectedItemIndex })))));
};
const ConnectedGenderPicker = connector(GenderPicker);
export { ConnectedGenderPicker as GenderPicker };
